export const KEY_TYPE = {
  Detail: "Detail",
  Credential: "Credential",
  RequestUrl: "RequestUrl",
  Header: "Header",
  QueryParam: "QueryParam",
  RequestBody: "RequestBody",
  Authentication: "Authentication",
  Method: "Method",
  PASformats: "PASformats",
  ApiKey: "API Key",
  AttachmentSftp: "AttachmentSftp",
} as const;

export const SFTP_KEY = {
  Host: "Host",
  Port: "Port",
  Username: "Username",
  Password: "Password",
  RemotePath: "RemotePath",
} as const;

export const DETAIL_KEY = {
  TokenUrl: "TokenUrl",
  ClientId: "ClientId",
  Scope: "Scope",
  Username: "Username",
  HeaderName: "HeaderName",
  QuestionSource: "QuestionSource",
  RequestFormat: "RequestFormat",
  ResponseFormat: "ResponseFormat",
  SamplePayload: "SamplePayload",
  Method: "Method",
  /** Legacy detail key — read-only fallback for configs saved before ConfigurationTypeId */
  CrdEndpointType: "CrdEndpointType",
} as const;

export const CREDENTIAL_KEY = {
  ClientSecret: "ClientSecret",
  BearerToken: "BearerToken",
  Password: "Password",
  ApiKey: "ApiKey",
} as const;

export const AUTH_KEY = {
  BearerToken: "BearerToken",
  Username: "Username",
  Password: "Password",
  ApiKey: "ApiKey",
} as const;

export const REQUEST_URL_KEY = {
  TokenUrl: "TokenUrl",
} as const;

export const REQUEST_BODY_KEY = {
  ClientId: "ClientId",
  ClientSecret: "ClientSecret",
  Scope: "Scope",
} as const;

export const TEST_STATUS = {
  Success: "SUCCESS",
  Failed: "FAILED",
} as const;

export const isTestSuccess = (testStatus?: string | null) =>
  (testStatus || "").toUpperCase() === TEST_STATUS.Success;
